'use strict';

const moment=require('pulsar-utils/dist-es6/time/moment');
const BaseService=require('../../../dist-es6/client/angularCommon/baseService');let

DateService=class DateService extends BaseService{
constructor(){
super();

this.reset();
}

reset(){
this._now=()=>new Date;
this._isMocked=!1;
}

setMockDate(date){
this._now=()=>new Date(date);
this._isMocked=!0;
}

get isMocked(){
return this._isMocked;
}

now(){
return this._now();
}

currentDateString(){
return this.getLocalDateStringFor(this.now());
}

getLocalDateStringFor(date){
return moment.utc(date).local().format(`YYYY-MM-DD`);
}};


module.exports=DateService;
//# sourceMappingURL=dateService.js.map
